/** @jsxImportSource @emotion/react */

import { useTheme } from '@emotion/react';
import { PenTool as PenToolIcon } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import lineDrawer from 'modules/overlay-canvas/addons/line-drawer';
import UDIconButton from 'ud-ui/components/icon-button';
import UDTippy from 'ud-ui/components/tippy';
import { selectActiveModal, selectFabricManager } from 'modules/template-editor/store/editor/selectors';

export function PenTool() {
  const theme = useTheme();
  const activeModal = useSelector(selectActiveModal);
  const fabricManager = useSelector(selectFabricManager);
  const [isSelected, setSelected] = useState<boolean>(false);

  useEffect(() => {
    const unsubscribe = lineDrawer.drawMode.subscribe((value) => {
      setSelected(value);
    });
    return () => unsubscribe();
  }, []);

  const onClickPen = () => {
    if (!fabricManager) return;
    if (isSelected) {
      setSelected(false);
      lineDrawer.edit();
      return;
    }

    setSelected(true);
    lineDrawer.draw();
  };

  return (
    <UDTippy disabled={Boolean(activeModal)} content={'Перо'} size="xs">
      <span style={{ display: 'inline-block' }}>
        <UDIconButton
          variant="ghost"
          icon={<PenToolIcon size={20} strokeWidth={1.5} />}
          style={{ color: isSelected ? theme.colors.DarkYellow : undefined }}
          onClick={onClickPen}
          tabIndex={0}
        />
      </span>
    </UDTippy>
  );
}
